var RenderTexture = (function () {
    function RenderTexture() {
    }
    return RenderTexture;
}());
export { RenderTexture };
